import React, { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useGetProfile from './useGetProfile';
import { isAllowedDomain } from 'src/utils/emailUtils';

const useSupportTracker = () => {

  const User = JSON.parse(localStorage.getItem('User'));
  const [getProfile] = useGetProfile();
  const location = useLocation()

  const initializeSupportlyWidget = () => {
    // Remove any existing Supportly script
    const existingBridgScript = document.querySelector('script[src="https://bridg.one/widget.js"]');
    const existingBridgContainer = document.querySelectorAll('#bridg-chat-container')?.length > 0
    if(existingBridgScript) existingBridgScript?.remove();
    if(existingBridgContainer) document.querySelectorAll('#bridg-chat-container')?.forEach(el => el?.remove());
    // Get user info from your application
    const currentUser = {
      id: User?.email || null,
      name: User?.fullName || null,
      email: User?.email || null,
      clientId: getProfile?.accountInfo?.name || "Hector",
    };

    // Configure Supportly
    window.bridgConfig = {
      clientId: currentUser.clientId,
      position: "right",
      primaryColor: "#221d70",
      userId: currentUser.id,
      userName: currentUser.name,
      userEmail: currentUser.email,
      companyName: 'Hector'
    };

    // Load Supportly script
    const script = document.createElement("script");
    script.src = "https://bridg.one/widget.js";
    script.async = true;
    document.body.appendChild(script);
    // Add custom styles for Supportly widget
    const style = document.createElement('style');
    style.textContent = `
      div#bridg-chat-container {
        left: 10px !important;
        bottom: 50px !important;
        right: unset !important;
      }
      .bridg-chat-widget.open {
          right: unset !important;
          left: 80px !important;
      }
    `;
    document.head.appendChild(style);
  };

  const updateSupportlyUser = useCallback(() => {
    const currentUser = {
      id: User?.email || null,
      name: User?.fullName || null,
      email: User?.email || null,
      clientId: getProfile?.accountInfo?.name || "Hector",
    };
        
    if (window.bridgConfig) {
      window.bridgConfig.userId = currentUser?.id || null;
      window.bridgConfig.userName = currentUser?.name || null;
      window.bridgConfig.userEmail = currentUser?.email || null;
      window.bridgConfig.clientId = currentUser?.clientId || "Hector";
      window.bridgConfig.companyName = 'Hector';
    }
  }, [User?.fullName, User?.email, getProfile?.accountInfo?.name]);

  // Initialize widget when component mounts
  useEffect(() => {
    // process.env.REACT_APP_IS_LOCAL != 1 &&
    if ( getProfile?.accountInfo?.name && User?.email && isAllowedDomain(User.email)) {
      console.log("initializeSupportlyWidget", {
        getProfile,
        User
      });
      // initializeSupportlyWidget();
    }

    return () => {
      const existingBridgScript = document.querySelector('script[src="https://bridg.one/widget.js"]');
      const existingBridgContainer = document.querySelectorAll('#bridg-chat-container')?.length > 0
      if(existingBridgScript) existingBridgScript?.remove();
      if(existingBridgContainer) document.querySelectorAll('#bridg-chat-container')?.forEach(el => el?.remove());
    }
  }, [getProfile?.accountInfo?.name, User?.email, location]);

  // Update user info when profile changes
  useEffect(() => {
    if (User) {
      updateSupportlyUser(User);
    }
  }, [User]);

  return {
    initializeSupportlyWidget,
    updateSupportlyUser
  };
};

export default useSupportTracker;
